var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('border'),_c('text',{staticStyle:{"font-weight":"300"},attrs:{"x":"50%","y":"50%","text-anchor":"middle","stroke":"#586E82","dy":".3em"}},[_vm._v(" "+_vm._s(_vm.name.replace(/key_/gi, ''))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }